import { createContext, useContext } from 'react';
import type { TrackAll } from './trackers/trackAll';

const trackAll: TrackAll = () => {};
const setIsReady = (_isReady: boolean) => {};

export const TrackingContext = createContext({
  isReady: false,
  setIsReady,
  trackAll,
});
export const useTrackingContext = () => useContext(TrackingContext);
